import {LoginPage} from './login-page';
export function RegisterPage(_props: any) { return <LoginPage />; }
